import { Link } from 'react-router-dom';
import LanguageSelector from '../components/LanguageSelector';
import LegalDocument from '../components/LegalDocument';
import useTranslation from '../data/useTranslation';
import legalNoticesFr from '../data/legal/legalNotices.fr';
import legalNoticesEn from '../data/legal/legalNotices.en';

function LegalNotices() {
  const { t, language } = useTranslation();
  const l = t.legal;
  const markdown = language === 'en' ? legalNoticesEn : legalNoticesFr;

  return (
    <div className="min-h-screen bg-[#111827] text-white" data-testid="legal-notices-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#111827]/95 backdrop-blur-md border-b border-gray-800">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2" data-testid="legal-home-link">
            <span className="text-2xl font-bold text-orange-500">BPM</span>
            <span className="hidden sm:inline text-sm text-gray-500">Beyond Personal Matrix</span>
          </Link>
          <LanguageSelector />
        </div>
      </header>

      <main className="max-w-3xl mx-auto pt-28 pb-16 px-6">
        <LegalDocument markdown={markdown} testId="legal-notices-body" />

        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link
            to="/"
            className="inline-block text-orange-400 hover:underline text-sm"
            data-testid="legal-back-link"
          >
            ← {l.backToHome}
          </Link>
        </div>
      </main>

      <footer className="py-8 border-t border-gray-800">
        <div className="container mx-auto px-6 text-center text-sm text-gray-600">
          {t.landing.copyright}
        </div>
      </footer>
    </div>
  );
}

export default LegalNotices;
